import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import Swiper, { Navigation, Scrollbar, Mousewheel } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/swiper-bundle.css';

function Top() {
  // MVの動き
  const fv = document.querySelector('.fv');
  const mainCatch = document.querySelector('.fv__catch');
  const subCatch = document.querySelector('.fv__catchSub');
  const txt = document.querySelector('.fv__txt');
  const imgFirst = document.querySelector('.fv__imgSub--01');
  const imgSecond = document.querySelector('.fv__imgSub--02');

  const Mv = () => {
    const mvTL = gsap.timeline();
    mvTL
      .to(imgFirst, {
        autoAlpha: 1,
        left: 0,
        duration: 1,
      })
      .to(
        imgSecond,
        {
          autoAlpha: 1,
          left: 0,
          duration: 1,
        },
        '>-0.3'
      )
      .to(mainCatch, {
        autoAlpha: 1,
        y: -50,
        duration: 1,
      })
      .to(subCatch, {
        autoAlpha: 1,
        y: -50,
        duration: 1,
      });

    gsap.from(txt, {
      autoAlpha: 0,
      y: 50,
      duration: 1,
      scrollTrigger: {
        trigger: fv,
        start: '30% top',
      },
    });
  };

  // PRODUCT DEVELOPMENTエリア
  const devMv = document.querySelector('.development__mv');
  const devTtl = document.querySelector('.development__ttl');

  const devContent = document.querySelector('.development__container');

  const ProductDev = () => {
    ScrollTrigger.create({
      trigger: '.development',
      start: 'top top',
      end: 'bottom top',
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
    });

    const devTL = gsap.timeline({
      scrollTrigger: {
        trigger: devMv,
        start: '15% top',
      },
    });
    devTL
      .to(devTtl, {
        autoAlpha: 0,
        y: -20,
        duration: 1,
      })
      .to(devMv, {
        scale: 0.95,
        duration: 0.3,
        scrollTrigger: {
          trigger: devMv,
          start: '15% top',
          scrub: true,
        },
      })
      .from(devContent, {
        autoAlpha: 0,
        y: 20,
        duration: 1,
      });
  };

  // NEWS スライダー
  const NewsSlider = () => {
    const option = {
      modules: [Navigation, Scrollbar, Mousewheel],
      slidesPerView: 4.2,
      spaceBetween: 20,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true,
      },
    };
    const swiperNews = new Swiper('.news__slider', option);
  };

  // Questionのプルダウン
  const QuestionAnswer = () => {
    const question = document.querySelectorAll('.qa__qContainer');
    const plus = question.forEach((q) =>
      q.addEventListener('click', function () {
        this.nextElementSibling.classList.toggle('isShow');
        this.lastElementChild.lastElementChild.classList.toggle('rotate');
      })
    );
  };

  const init = () => {
    Mv();
    ProductDev();
    QuestionAnswer();
    NewsSlider();
  };

  const mediaQuery = window.matchMedia('(min-width: 600px)');
  if (mediaQuery.matches) {
  }

  init();
}
export default Top;
